import { registerCustomTheme, resolveTheme } from '@pierre/diffs'

declare global {
  var __tentarcCraftDiffThemesRegistered: boolean | undefined
}

export function ensureCraftDiffThemesRegistered(): void {
  if (globalThis.__tentarcCraftDiffThemesRegistered) return
  globalThis.__tentarcCraftDiffThemesRegistered = true

  registerCustomTheme('craft-dark', async () => {
    const theme = await resolveTheme('pierre-dark')
    return {
      ...theme,
      name: 'craft-dark',
      bg: 'transparent',
      colors: { ...theme.colors, 'editor.background': 'transparent' },
    }
  })

  registerCustomTheme('craft-light', async () => {
    const theme = await resolveTheme('pierre-light')
    return {
      ...theme,
      name: 'craft-light',
      bg: 'transparent',
      colors: { ...theme.colors, 'editor.background': 'transparent' },
    }
  })
}
